export const threeYears = '3 years';
export const fiveYears = '5 years';
export const sevenYears = '7 years';

export const contractType = [threeYears, fiveYears, sevenYears] as const;
export type ContractType = typeof contractType[number];
